import { useMemo } from 'react'
import { useStore } from '@/store'
import DetailTable from './DetailTable'
import { hexItemsToDetailRows } from './detailRows'
import { useHexItems, type HexItem } from '@/hooks/useHexItems'

/**
 * Tabular mirror of the Hex chart: driven by the SAME `useHexItems()` the grid
 * renders, so every tile has exactly one row with the same totals and severity.
 * Row click = the tile's drill gesture.
 */
export default function HexDetailTable() {
  const items = useHexItems()
  const dimension = useStore((s) => s.dimension)
  const descendToStreams = useStore((s) => s.descendToStreams)
  const drillToStream = useStore((s) => s.drillToStream)
  const addComparisonStream = useStore((s) => s.addComparisonStream)

  const rows = useMemo(() => {
    const activate = (item: HexItem) => {
      if (dimension === 'studio' || dimension === 'game') {
        descendToStreams(dimension, item.id)
        return
      }
      if (dimension === 'stream') {
        const sid = String(item.id ?? '').trim()
        if (!sid) return
        addComparisonStream(sid)
        drillToStream(sid)
      }
    }
    return hexItemsToDetailRows(items, activate)
  }, [items, dimension, descendToStreams, drillToStream, addComparisonStream])

  return <DetailTable rows={rows} emptyText="No data for the current filters." showStreams={false} />
}
